// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
/**
 * @packageDocumentation
 * @module docmanager
 */
export * from './dialogs';
export * from './manager';
export * from './pathstatus';
export * from './savehandler';
export * from './savingstatus';
export * from './tokens';
export * from './widgetmanager';
export * from './recents';
//# sourceMappingURL=index.js.map